import baseAction from './_base';
import {CHECK_NO_AUTH} from './actionTypes';
import qs from 'querystring';

export function checkNoAuth(data) {
  return baseAction(CHECK_NO_AUTH, '/v1/noAuth?' + qs.stringify(data));
}



/** WEBPACK FOOTER **
 ** ./src/_shared/actions/checkNoAuth.js
 **/